import * as React from 'react';
import { useDispatch } from 'react-redux';

import { TextWithLink } from './TextWithLink';
import { openFeedbackPopup } from '../../../actions/feedback';

export const TextWithLinkContainer = () => {
  const dispatch = useDispatch();

  const onClick = React.useCallback(() => {
    dispatch(openFeedbackPopup());
  }, []);

  return <TextWithLink onClick={onClick} />;
};
